import { useEffect } from 'react'
import { useTenant } from '@emerald-works-nova/auth'
import { useLocation, useParams } from 'react-router-dom'
import { useEvent } from '@emerald-works/react-event-bus-client'

export const useStackOneTrackCompletion = () => {
  const tenant = useTenant()
  const { locationId } = useParams()
  const { search } = useLocation()
  const [stackOneTrackCompletion] = useEvent([{
    eventName: 'stackOneTrackCompletion'
  }])

  const hasStackOneIntegrationEnabled = tenant?.features?.stackOne?.accountId

  useEffect(() => {
    if (!locationId || !hasStackOneIntegrationEnabled) return
    console.log('Triggering stackOneTrackCompletion event')
    const urlQueryObject = Array.from(new URLSearchParams(search)).reduce((acc, [key, value]) => {
      acc[key] = value
      return acc
    }, {})
    // console.log({ urlQueryObject })
    stackOneTrackCompletion.trigger({
      locationId,
      queryParams: urlQueryObject
    })
  }, [hasStackOneIntegrationEnabled, stackOneTrackCompletion, locationId, search])
}
